import React from 'react';
import { useTranslation } from 'react-i18next';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

function AiPlaygroundHeader() {
  const { t } = useTranslation('header');
  return (
    <ProjectNameHeader
      icon={SmartToyOutlinedIcon}
      selector={() => null}
      defaultName={t('aiPlayground')}
      iconProps={{ color: 'var(--color-primary)', disableCommonStyles: true }}
    />
  );
}

export default AiPlaygroundHeader;
